import $ from "jquery";
import "bootstrap/js/dist/tab";
import "bootstrap/js/dist/modal";
import placesAutoComplete from "google/places-auto-complete";
import pageData from "common/page-data";
import "common/address-search";
import "../../assets/javascripts/external/typed";

const ANIMATION_CONFIG = {
  strings: [
    "it's just listed",
    "the price has been reduced",
    "it's just sold",
    "it's a vacation property",
    "it needs an extra boost",
    "you need to impress a client"
  ],
  typeSpeed: 40,
  backSpeed: 80,
  backDelay: 3500,
  contentType: "html",
  showCursor: false,
  loop: true,
  loopCount: 2,
  deleteType: "fade"
};

const UNDERLINE_STYLE = "2px solid #fff";

placesAutoComplete.initializeCityState(
  ".js-real-estate-profile-search-form-city-state",
  null,
  pageData.get("currentCountry")
);

$(() => {
  const $animated = $(".animated-text");

  if (!$animated.length) return;

  const applyUnderline = () => $animated.css("border-bottom", UNDERLINE_STYLE);

  $animated.typed({
    ...ANIMATION_CONFIG,
    callback: applyUnderline,
    onStringTyped: applyUnderline,
    resetCallback: applyUnderline
  });

  applyUnderline();

  if (window.MutationObserver) {
    const observer = new MutationObserver(applyUnderline);

    $animated.each((_, element) => {
      observer.observe(element, {
        childList: true,
        characterData: true,
        subtree: true
      });
    });
  }
});

$(document).on("shown.bs.modal", e => {
  const $modal = $(e.target);
  const $inputs = $modal
    .find(".listings-search-form-address")
    .filter((_, el) => !$(el).data("places-initialized"));

  if (!$inputs.length) return;

  $inputs.each((_, el) => $(el).data("places-initialized", true));

  placesAutoComplete
    .initializeAddress($inputs, false, pageData.get("currentCountry"))
    .catch(error => {
      console.error("Failed to initialize address search in modal:", error);
    });
});
